<template>
  <v-container>
    <module-bar title="DATOS DEL USUARIO" />
    <v-card outlined>
      <v-card-text>
        <h4>Cambiar mi clave</h4>
        <v-form v-model="valid" ref="formChangePwd">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Password"
                v-model="password"
                :rules="rulesPassword"
                type="password"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Repetir Password"
                v-model="repassword"
                :rules="rulesRepassword"
                type="password"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          :loading="loadingChangePwd"
          @click="changePwd"
          >Cambiar password</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import ModuleBar from "../components/General/ModuleBar.vue";
export default {
  components: { ModuleBar },

  data() {
    return {
      valid: false,
      loadingChangePwd: false,
      password: "",
      repassword: "",

      rulesPassword: [
        (value) => (value && value.length >= 6) || "Ingrese el password",
      ],
      rulesRepassword: [
        (value) => (value && value.length >= 6) || "Confirme el password",
        (value) =>
          (value && value == this.password) || "Debe ser igual al password",
      ],
    };
  },

  methods: {
    changePwd() {
      if (this.valid) {
        this.loadingChangePwd = true;
        setTimeout(() => {
          this.$store
            .dispatch("changePwdAction", this.password)
            .then(() => {
              this.loadingChangePwd = false;
            })
            .catch(() => {
              this.loadingChangePwd = false;
            });
        }, 500);
      } else {
        this.$refs.formChangePwd.validate();
      }
    },
  },
};
</script>

<style></style>
